<template>
  <label @click="lableOnClick()" class="checkbox-label" :style="isMobile()?'left:0':''" :class="isSushi && ' montserrat-500'">
   <span class="p-0 m-0 " :style="isSushi && 'color:#000000; font-size:14px'"> {{label}}</span>
    <input
      type="checkbox"
      v-on:click.stop="onClick()"
      :class="isSushi && 'color-sushi'"
      :checked="value"
      :disabled="disabled"
    />
    <span :class="IsRadio?'radio-checkmark':'checkbox-checkmark'" :style="getStyle()"></span>
  </label>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Checkbox",
  props: {
    label: {
      type: String,
      default: "label"
    },
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    IsRadio: {
      type: Boolean,
      default: false
    },
    isSushi : {
      type: Boolean
    }
  },
  mounted: function() {
    this.$el.indeterminate = true;
  },
  computed: {
    ...mapGetters(["desktopStyles", "mobileStyles"])
  },
  methods: {
    onClick() {
      switch (this.value) {
        case null:
        case false:
          this.$emit("change", true);
          this.$emit("input", true);
          this.$emit("click", true);
          break;
        case true:
          this.$emit("change", false);
          this.$emit("input", false);
          this.$emit("click", false);
          break;
      }
    },
    lableOnClick() {
      this.$emit("click", this.value);
    },
    getStyle() {
      var style = [];
      if (this.value) {

        if(this.isSushi){
          console.log("sushi push")
          let sushiCommonColorBackground = {
            "background-color": `#F04653 !important`,
          }
          style.push(sushiCommonColorBackground);
        }
        else {
          style.push(
              this.isMobile()
                  ? this.mobileStyles.CommonColorBackground
                  : this.desktopStyles.CommonColorBackground
          );
        }

      } else {
        style.push(
          this.isMobile()
            ? this.mobileStyles.pendingStatusBackground
            : this.desktopStyles.pendingStatusBackground
        );
      }
      return style;
    }
  }
};
</script>
